export { WhiteButton } from './white-button';
export type { WhiteButtonProps } from './white-button';
